import { useFeatureFlag } from "@qualio/ui-components";
import { FeatureFlags } from "@design-controls/types";
import { formatDesignElementVersion } from "../../domain/designElementVersion";

/**
 * The item's major.minor version for display, or undefined when it should be
 * hidden — the flag is off, or the item has no version numbers.
 *
 * Returning undefined matters: QHorizontalMetadata drops a child whose `value`
 * prop is undefined along with its dot separator, whereas a child that renders
 * null still gets a separator.
 */
export const useDesignElementVersion = (
  major?: number | null,
  minor?: number | null,
): string | undefined => {
  const versioningEnabled = Boolean(
    useFeatureFlag()[FeatureFlags.MAJOR_MINOR_VERSION_UI],
  );

  if (!versioningEnabled) {
    return undefined;
  }

  return formatDesignElementVersion(major, minor);
};
